export const CREATE_EXPENSE_TYPE_MUTATION = `
  mutation CreateExpenseType($object: expense_types_insert_input!) {
    insert_expense_types_one(object: $object) {
      id
      expense_type_name
      expense_type_description
      expense_type_status
      company_id
      created_at
    }
  }
`;

export const UPDATE_EXPENSE_TYPE_MUTATION = `
  mutation UpdateExpenseType($id: Int!, $set: expense_types_set_input!) {
    update_expense_types_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      expense_type_name
      expense_type_description
      expense_type_status
      company_id
      created_at
    }
  } 
`;

export const DELETE_EXPENSE_TYPE_MUTATION = `
  mutation DeleteExpenseType($id: Int!) {
    delete_expense_types_by_pk(id: $id) {
      id
      expense_type_name
    }
  }
`; 